import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

import { observable, runInAction, makeObservable, computed } from "mobx";
import { DEFAULT_MAX_CC_NUMBER_LENGTH, InputAction } from "@dp/common";
import { insertDelimiters } from "@dp/common";
var GiftCardModel = (_class = /*#__PURE__*/function () {
  function GiftCardModel() {
    _classCallCheck(this, GiftCardModel);

    _initializerDefineProperty(this, "_gcNumber", _descriptor, this);

    _initializerDefineProperty(this, "_isCaptchaValid", _descriptor2, this);

    _initializerDefineProperty(this, "_gcBalance", _descriptor3, this);

    _initializerDefineProperty(this, "_captchaToken", _descriptor4, this);

    _initializerDefineProperty(this, "_errorMessage", _descriptor5, this);

    _initializerDefineProperty(this, "_saveGiftCardToProfile", _descriptor6, this);

    _initializerDefineProperty(this, "_giftCardToDelete", _descriptor7, this);

    _initializerDefineProperty(this, "_isGiftCardSuccessfullyDeleted", _descriptor8, this);

    _initializerDefineProperty(this, "_gcID", _descriptor9, this);

    makeObservable(this);
  }

  _createClass(GiftCardModel, [{
    key: "gcNumber",
    get: function get() {
      return this._gcNumber;
    },
    set: function set(val) {
      var _this = this;

      if (val) {
        // eslint-disable-next-line no-debugger
        var existing = this._gcNumber;
        var action = existing && val.length < existing.length ? InputAction.DELETE : InputAction.ADD;
        var gaps = [4, 8, 12]; // TODO: Remove hardcoded gaps

        var formattedCCNumber = insertDelimiters(val, gaps, "-", action);
        var gcNum = formattedCCNumber ? formattedCCNumber.split("-").join("") : "";
        var isNumber = /^\d+$/.test(gcNum);

        if (isNumber) {
          runInAction(function () {
            _this._gcNumber = formattedCCNumber;
          });
        }
      } else {
        runInAction(function () {
          _this._gcNumber = val;
        });
      }
    }
  }, {
    key: "saveGiftCardToProfile",
    get: function get() {
      return this._saveGiftCardToProfile;
    },
    set: function set(saveGiftCardToProfile) {
      var _this2 = this;

      runInAction(function () {
        _this2._saveGiftCardToProfile = saveGiftCardToProfile;
      });
    }
  }, {
    key: "maxLength",
    get: function get() {
      var gaps = [4, 8, 12];
      return gaps.length + DEFAULT_MAX_CC_NUMBER_LENGTH;
    }
  }, {
    key: "isCaptchaValid",
    get: function get() {
      return this._isCaptchaValid;
    },
    set: function set(isCaptchaValid) {
      var _this3 = this;

      runInAction(function () {
        _this3._isCaptchaValid = isCaptchaValid;
      });
    }
  }, {
    key: "errorMessage",
    get: function get() {
      return this._errorMessage;
    },
    set: function set(errorMessage) {
      var _this4 = this;

      runInAction(function () {
        _this4._errorMessage = errorMessage;
      });
    }
  }, {
    key: "gcBalance",
    get: function get() {
      return this._gcBalance;
    },
    set: function set(gcBalance) {
      var _this5 = this;

      runInAction(function () {
        _this5._gcBalance = gcBalance;
      });
    }
  }, {
    key: "captchaToken",
    get: function get() {
      return this._captchaToken;
    },
    set: function set(captchaToken) {
      var _this6 = this;

      runInAction(function () {
        _this6._captchaToken = captchaToken;
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.isCaptchaValid && this.gcBalance > 0;
    }
  }, {
    key: "isGCNumberValid",
    get: function get() {
      return this.gcNumber && this.gcNumber.length === this.maxLength;
    }
  }, {
    key: "rawGCNumber",
    get: function get() {
      return this.gcNumber && this.gcNumber.split("-").join("");
    }
  }, {
    key: "giftCardToDelete",
    get: function get() {
      return this._giftCardToDelete;
    },
    set: function set(giftCard) {
      var _this7 = this;

      runInAction(function () {
        _this7._giftCardToDelete = giftCard;
      });
    }
  }, {
    key: "isGiftCardSuccessfullyDeleted",
    get: function get() {
      return this._isGiftCardSuccessfullyDeleted;
    },
    set: function set(status) {
      var _this8 = this;

      runInAction(function () {
        _this8._isGiftCardSuccessfullyDeleted = status;
      });
    }
  }, {
    key: "giftCardID",
    get: function get() {
      return this._gcID;
    },
    set: function set(id) {
      var _this9 = this;

      runInAction(function () {
        _this9._gcID = id;
      });
    }
  }]);

  return GiftCardModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_gcNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_isCaptchaValid", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_gcBalance", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_captchaToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_errorMessage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_saveGiftCardToProfile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_giftCardToDelete", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_isGiftCardSuccessfullyDeleted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_gcID", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "gcNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "gcNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveGiftCardToProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "saveGiftCardToProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxLength", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxLength"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCaptchaValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCaptchaValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gcBalance", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "gcBalance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "captchaToken", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "captchaToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGCNumberValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGCNumberValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rawGCNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rawGCNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "giftCardToDelete", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "giftCardToDelete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGiftCardSuccessfullyDeleted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGiftCardSuccessfullyDeleted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "giftCardID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "giftCardID"), _class.prototype)), _class);
export { GiftCardModel as default };